import { AddIcon, DownloadIcon } from "@/assets/icons";
import { uploadUsersToGroups } from "@/helpers/apis";
import { LoadingButton } from "@altimateai/lego";
import { ChangeEvent } from "react";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from "@altimateai/lego";
import UploadStatusModal from "./UploadStatusModal";
import { isAdmin, isOwner } from "@/services/auth";
import { Button, Label, Stack } from "@altimateai/lego";
import { UsersInGroupCsvFileUrl } from "./assets";
import { useParams } from "react-router-dom";
import AddNewMember from "./AddNewMember";

const UploadUsersButton = () => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const { mutate, isPending: isLoading, data } = useMutation({
    mutationFn: uploadUsersToGroups,
    onSuccess: result => {
      if (!result) return;
      if (!result.failures.length) {
        toast({ description: "Adding users to team was successful" });
        queryClient.invalidateQueries({ queryKey: ["UserGroupDetails"] });
        return;
      }
    },
    onError: (error: Error) => {
      toast({ description: `Upload failed: ${error.message || error}`, variant: "destructive" });
    },
  });

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    mutate(formData);
  };

  if (!isOwner() && !isAdmin()) {
    return null;
  }

  return (
    <>
      <Stack>
        <Button
          title="Sample CSV files with required columns and possible values"
          variant="secondary"
          asChild
        >
          <a href={UsersInGroupCsvFileUrl} download="users_in_group_template.csv">
            <DownloadIcon />
            Download template
          </a>
        </Button>
        <LoadingButton
          className="!al-p-0"
          variant="secondary"
          loading={isLoading}
          title="Upload CSV file to add users"
          aria-label="Upload CSV file to add users"
        >
          <Label className={"al-flex al-gap-2 al-items-center al-cursor-pointer al-px-3 al-py-2"} htmlFor={"users-file-upload"}>
            <AddIcon />
            Bulk upload members
            <input
              id={"users-file-upload"}
              type="file"
              className="al-hidden"
              onChange={handleFileUpload}
              accept={".csv"}
            />
          </Label>
        </LoadingButton>
        <AddNewMember groupId={id!} />
      </Stack>
      <UploadStatusModal failures={data?.failures} success={data?.success} uploadType="user" />
    </>
  );
};

export default UploadUsersButton;
